import { Stack } from "@mui/material";
import React from "react";
import AutoScrollingChips from "../Horizontal Accordion/AutoScrollingChips";
import ScrollingChips from "./ScrollingChips";

const Section2 = () => {
  return (
    <Stack>
      <Stack>
        <Stack sx={{}}>
          <Stack>
            <Stack
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: {
                  xs: "28px",
                  sm: "28px",
                  md: "40px",
                  lg: "40px",
                  xl: "20px",
                },
                paddingTop: {
                  xs: "28px",
                  sm: "28px",
                  md: "40px",
                  lg: "40px",
                  xl: "40px",
                },
              }}
            >
              <Stack
                sx={{
                  fontSize: {
                    xs: "22px",
                    sm: "28px",
                    md: "48px",
                    lg: "48px",
                    xl: "48px",
                  },
                  lineHeight: {
                    xs: "32px",
                    sm: "32px",
                    md: "62px",
                    lg: "62px",
                    xl: "62px",
                  },
                  fontWeight: { xs: 600, sm: 600, md: 600, lg: 600, xl: 600 },
                  color: "black",
                  fontFamily:
                    "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                }}
              >
                {" "}
                Founders & Marketers Love us{" "}
              </Stack>
            </Stack>
          </Stack>

          <Stack>
            <Stack
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Stack
                sx={{
                  fontSize: {
                    xs: "16px",
                    sm: "12px",
                    md: "24px",
                    lg: "30px",
                    xl: "30px",
                  },
                  lineHeight: {
                    xs: "22px",
                    sm: "22px",
                    md: "30px",
                    lg: "30px",
                    xl: "40px",
                  },
                  fontWeight: { xs: 400, sm: 400, md: 300, lg: 300, xl: 300 },
                  color: "black",
                  // border: "1px solid white",
                  width: {
                    xs: "84%",
                    sm: "52%",
                    md: "80%",
                    lg: "76%",
                    xl: "100%",
                  },
                  marginBottom: {
                    xs: "28px",
                    sm: "28px",
                    md: "40px",
                    lg: "40px",
                    xl: "40px",
                  },
                  fontFamily:
                    "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                }}
                textAlign={"center"}
              >
                {" "}
                Trusted by 50000+ Businesses across 53+ Countries
              </Stack>
            </Stack>
          </Stack>

          {/* <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              border: "1px solid red",
            }}
          >
            {" "}
            <Stack
              sx={{
                border: "1px solid blue",
                width: { xl: "84%", lg: "90%" },
                height: "80px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ScrollingChips />
            </Stack>
          </Stack> */}

          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              // border: "1px solid red", // Red border
              width: "100%", // Ensure it spans the screen width
              overflow: "hidden", // Prevent blue-bordered stack from exceeding
            }}
          >
            <Stack
              sx={{
                // border: "1px solid blue", // Blue border
                width: { xl: "100%", lg: "100%", xs: "100%" }, // Full width inside red stack
                height: "80px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden", // Prevent ScrollingChips from exceeding
              }}
            >
              <ScrollingChips />
            </Stack>
          </Stack>

          <Stack>
            <Stack
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginTop: { xl: "40px", lg: "40px" },
              }}
            >
              <Stack
                sx={{
                  fontSize: {
                    xs: "22px",
                    sm: "28px",
                    md: "48px",
                    lg: "48px",
                    xl: "48px",
                  },
                  lineHeight: {
                    xs: "32px",
                    sm: "32px",
                    md: "62px",
                    lg: "62px",
                    xl: "62px",
                  },
                  fontWeight: { xs: 600, sm: 600, md: 600, lg: 600, xl: 600 },
                  color: "black",
                  // border: "1px solid white",
                  width: {
                    xs: "84%",
                    sm: "52%",
                    md: "80%",
                    lg: "76%",
                    xl: "100%",
                  },
                  marginBottom: {
                    xs: "28px",
                    sm: "28px",
                    md: "40px",
                    lg: "40px",
                    xl: "40px",
                  },
                  fontFamily:
                    "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                }}
                textAlign={"center"}
              >
                {" "}
                <span>
                  {" "}
                  Explore more industry-wise whatsApp
                  <span style={{ color: "#0d5394" }}> use cases</span>
                </span>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Section2;
